import PropTypes from 'prop-types';
import assignment from './assignment';

const availability = PropTypes.shape({
  restStart: PropTypes.string,
  restDuration: PropTypes.number,
  dropCellTargets: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  assignments: PropTypes.arrayOf(assignment),
  deletedOn: PropTypes.string,
  duration: PropTypes.number.isRequired,
  endDate: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  startDate: PropTypes.string.isRequired,
});

export default availability;
